// Services tab (§3): "Account services" section with the Beneficiary
// Management tile. Gated like the Pay tab.
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faHandHoldingDollar, faUsers } from '@fortawesome/free-solid-svg-icons';
import MobileBankingGate from '@/components/common/MobileBankingGate';
import './services.css';

const Services = () => {
  const navigate = useNavigate();
  return (
    <MobileBankingGate>
      <div className="nova-services-page">
        <h2 className="nova-services-title">Account services</h2>
        <div className="nova-services-grid">
          <button type="button" className="nova-services-tile" onClick={() => navigate('/beneficiaries')}>
            <span className="nova-services-tile-icon">
              <FontAwesomeIcon icon={faUsers} />
            </span>
            <span className="nova-services-tile-text">
              <span className="nova-services-tile-title">Beneficiary Management</span>
              <span className="nova-services-tile-sub">Add and manage the people you pay</span>
            </span>
            <FontAwesomeIcon icon={faChevronRight} className="nova-services-chevron" />
          </button>
          <button type="button" className="nova-services-tile" onClick={() => navigate('/borrow')}>
            <span className="nova-services-tile-icon">
              <FontAwesomeIcon icon={faHandHoldingDollar} />
            </span>
            <span className="nova-services-tile-text">
              <span className="nova-services-tile-title">Loans</span>
              <span className="nova-services-tile-sub">Apply for a loan or manage the ones you have</span>
            </span>
            <FontAwesomeIcon icon={faChevronRight} className="nova-services-chevron" />
          </button>
        </div>
      </div>
    </MobileBankingGate>
  );
};

export default Services;
